import React, { useState } from "react";

export default function useToggleExpand(initialState = false, externalRef = null) {
    const [expanded, setIsExpanded] = useState(initialState);
    const expand = (ref) => {
        setIsExpanded(prevExpanded => !prevExpanded);

        if (ref.current) {
            const element = ref.current;
            if (!element.style.height || element.style.height === '0px') {
                element.style.height = Array.prototype.reduce.call(
                    element.childNodes,
                    (acc, child) => acc + (child.offsetHeight || 0),
                    0
                ) + 'px';
            } else {
                element.style.height = '0px';
            }
        }
    };

    const recalculateHeight = (ref) => {
        if (ref.current) {
            const element = ref.current;
            if (element.style.height || element.style.height !== '0px') {
                element.style.height = Array.prototype.reduce.call(
                    element.childNodes,
                    (acc, child) => acc + (child.offsetHeight || 0),
                    0
                ) + 'px';
            }
        }
    }

    const closeExpand = (ref) => {
        if (ref.current) {
            const element = ref.current;

            element.style.height = '0px';
        }
    };

    return { expanded, expand, closeExpand, setIsExpanded, recalculateHeight };
}
